(function speciesOverviewScript($, Drupal) {
  Drupal.behaviors.speciesOverview = {
    attach(context) {
      $('.seafood_tab_link').on('click', (e) => {
        $("a[href='#seafood']").click();
      });
    },
  };
}(jQuery, Drupal));
